import { api } from "@/lib/api";

export const BRANCHES = ["Chennai", "Tada", "Hyderabad", "Jaipur"];

const BRANCH_PALETTE = [
  "border-emerald-300 bg-emerald-50 text-emerald-700",
  "border-sky-300 bg-sky-50 text-sky-700",
  "border-violet-300 bg-violet-50 text-violet-700",
  "border-orange-300 bg-orange-50 text-orange-700",
  "border-rose-300 bg-rose-50 text-rose-700",
  "border-cyan-300 bg-cyan-50 text-cyan-700",
  "border-lime-300 bg-lime-50 text-lime-700",
  "border-fuchsia-300 bg-fuchsia-50 text-fuchsia-700",
];

export function branchPillClass(branch) {
  const b = String(branch || "").trim();
  if (!b) return "border-slate-300 bg-slate-100 text-slate-600";
  let idx = BRANCHES.indexOf(b);
  if (idx < 0) {
    idx = 0;
    for (const ch of b) idx = (idx * 31 + ch.charCodeAt(0)) % 997;
  }
  return BRANCH_PALETTE[idx % BRANCH_PALETTE.length];
}

export async function loadBranches() {
  try {
    const r = await api.get("/branches");
    if (Array.isArray(r.data) && r.data.length) {
      BRANCHES.length = 0;
      BRANCHES.push(...r.data);
    }
  } catch (e) { /* keep defaults */ }
}
